import React, {Component} from 'react';
import Api from "../../utils/Api";
import StaticFunctions from "../../utils/StaticFunctions";
import TimeRange from "../../utils/TimeRange";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import LocationSelector from "../../globalComponents/LocationSelector";
import TableContainer from "../../utils/TableContainer";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import moment from "moment/moment";
import CheckBoxField from "../../utils/CheckBoxField";
import DOMDownloadButton from "../../utils/DOMDownloadButton";
import PDFDownloadButton from "../../utils/PDFDownloadButton";

class ReportShiftComparison extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null,
            showSubThreadbreaks: false,
            selectedLocationId: 0,
            selectedLocationName: 'all',
            selectedShift: null,
            requestedParams: null,
            tableData: null,
            errorData: null
        };

        this.reportKey = 'shiftComparison';

        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);

    }

    componentWillMount() {

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));
        if (tr && tr.isValid()) newState.timeRange = tr;

        // Standort aus den userprops laden
        const locationId = this.getReportSetting('locationId');

        if (locationId) newState.selectedLocationId = locationId;

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            const shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        // ShowSubThreadbreaks aus den userprops laden
        const showSubThreadbreaks = this.getReportSetting('showSubThreadbreaks', false);

        if (showSubThreadbreaks) newState.showSubThreadbreaks = true;

        if (newState) this.setState(newState);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.props.baseData.companies.currentCompany.id ||
                nextProps.baseData.companyLocations !== this.props.baseData.companyLocations ||
                nextProps.baseData.shifts.shifts !== this.props.baseData.shifts.shifts) {
                this.setState({
                    selectedLocationId: 0,
                    selectedLocationName: 'all',
                    selectedShift: null,
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const locationId = this.state.selectedLocationId;
        const allShifts = this.props.baseData.shifts.shifts;
        const shift = this.state.selectedShift ? this.state.selectedShift : this.props.baseData.shifts.nullShift;

        // Check, if all data is set
        if (!dateFrom || !dateTill || locationId === null || shift === null) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        return {
            companyId: this.props.baseData.companies.currentCompany.id,
            locationId: locationId,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showSubThreadbreaks: this.state.showSubThreadbreaks,
            shift: shift,
            allShifts: allShifts,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                this.setState({
                    reportStatus: 'ready',
                    tableData: res,
                    errorData: null,
                });
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    tableData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            tableData: null,
            errorData: null,
        }, () => {
            this.api.request('ReportShiftComparison', params, callback, error);
        });

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    locationSelected(location) {

        this.setState({
            selectedLocationId: location ? location.id : 0,
            selectedLocationName: location ? location.name : ''
        });

        if (this.saveSettings && location) {
            this.saveSettings('reports', {report: this.reportKey, key: 'locationId', value: location.id});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    toggleCheckBox(fieldName, isChecked) {

        const state = {...this.state};

        state[fieldName] = isChecked;

        this.setState(state);

        // Safe option to Userconfig
        if (this.saveSettings && isChecked !== null) {
            this.saveSettings('reports', {report: this.reportKey, key: fieldName, value: isChecked});
        }

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedLocationId === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('locationIsUnset')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedMachine === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('machineIsUnset')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedDesign === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (this.state.tableData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.tableData && this.state.tableData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {
            const location = {
                location: {
                    id: this.state.reportParams.selectedLocationId,
                    name: this.state.reportParams.selectedLocationName
                },
                locationTitle: this.translate('location'),
                allLocationsTitle: this.translate('allLocations')
            };

            csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange, location));
            csvContent.csvColumns.push(this.getTableColumns());
            csvContent.csvData.push(this.getCsvTableRows());
        }

        return csvContent;

    }

    getCsvTableRows() {

        const result = this.state.tableData;
        const rows = [];

        if (result) {
            result.forEach(
                (location, locationId) => {
                    location.machines.forEach(
                        (machine) => {
                            machine.shifts.forEach(
                                (shift) => {
                                    rows.push({
                                        id: locationId,
                                        location: location.locationName,
                                        machineId: machine.machineId.toString(),
                                        machineName: machine.machineName,
                                        shift: (shift.shiftName === 'all') ? '00:00 - 24:00' : shift.shiftName,
                                        stitches: StaticFunctions.formatedNumber(shift.stitches),
                                        threadbreaks: StaticFunctions.formatedNumber(shift.threadbreaks),
                                        threadBreaksPer10KStiches: StaticFunctions.calcThreadbreaksByRatio(shift.stitches, shift.threadbreaks).replace('.', ','),
                                    });
                                }
                            );
                        }
                    );
                }
            );
        }

        return rows;

    }

    getTableHeader() {

        const location = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
            locationTitle: this.translate('location'),
            allLocationsTitle: this.translate('allLocations')
        };

        const headLine = this.getChartHeadline(this.state.reportParams.timeRange, location);

        return (
            <nav>
                <h1>{headLine}</h1>
            </nav>
        );

    }

    getTableColumns() {

        return [
            {
                key: 'location',
                nameKey: 'location',
                sortType: 'string',
            },
            /*{
                key: 'from',
                nameKey: 'from',
            },
            {
                key: 'till',
                nameKey: 'till',
            },*/
            {
                key: 'machineId',
                nameKey: 'machineId',
                sortType: 'string',
            },
            {
                key: 'machineName',
                nameKey: 'machineName',
                sortType: 'string',
            },
            {
                key: 'shift',
                nameKey: 'shift',
            },
            {
                key: 'stitches',
                nameKey: 'stitches',
                classes: 'text-right',
            },
            {
                key: 'threadbreaks',
                nameKey: 'threadbreaks',
                classes: 'text-right',
            },
            {
                key: 'threadBreaksPer10KStiches',
                nameKey: 'threadBreaksPer10KStiches',
                classes: 'text-right',
            },
        ];

    }

    getTableRows() {

        const result = this.state.tableData;
        const rows = [];

        if (result) {
            result.forEach(
                (location, locationId) => {
                    location.machines.forEach(
                        (machine) => {
                            let shiftNames = [];
                            let shiftStitches = [];
                            let shiftThreadbreaks = [];
                            let shiftThreadBreaksPer10KStiches = [];

                            machine.shifts.forEach(
                                (shift) => {
                                    let tbp10ks = StaticFunctions.calcThreadbreaksByRatio(shift.stitches, shift.threadbreaks);

                                    shiftNames.push((shift.shiftName === 'all') ? '00:00 - 24:00' : shift.shiftName);
                                    shiftStitches.push(StaticFunctions.formatedNumber(shift.stitches));
                                    shiftThreadbreaks.push(StaticFunctions.formatedNumber(shift.threadbreaks));
                                    shiftThreadBreaksPer10KStiches.push(StaticFunctions.formatedNumber(tbp10ks, 2));
                                }
                            );

                            rows.push({
                                id: locationId,
                                location: location.locationName,
                                machineId: machine.machineId,
                                machineName: machine.machineName,
                                shift: this.renderTableContent(shiftNames),
                                stitches: this.renderTableContent(shiftStitches),
                                threadbreaks: this.renderTableContent(shiftThreadbreaks),
                                threadBreaksPer10KStiches: this.renderTableContent(shiftThreadBreaksPer10KStiches),
                            });
                        }
                    );
                }
            );
        }

        return rows;

    }

    renderTableContent(list) {

        return (
            <div>{
                list.map(
                    (item, index) => {
                        return <p key={index}>{item}</p>
                    }
                )
            }</div>
        );

    }

    renderTable() {

        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <TableContainer
                baseData={this.props.baseData}
                columns={tableColumns}
                rows={tableRows}
            />
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        const tableHeader = this.getTableHeader();
        const tableArea = this.renderTable();

        return (
            <div className="ma-bo-10">
                {tableHeader}

                {tableArea}
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('location')}</h4>

                                <div>
                                    <LocationSelector
                                        baseData={this.props.baseData}
                                        currentLocation={this.state.selectedLocationId}
                                        placeholder={this.translate('select') + '...'}
                                        onLocationSelected={(location) => this.locationSelected(location)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>

                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('options')}</h4>

                                <div className="formBox">
                                    <CheckBoxField
                                        name="showSubThreadbreaks"
                                        label={this.translate('showSubThreadbreaks')}
                                        isChecked={this.state.showSubThreadbreaks}
                                        onChange={this.toggleCheckBox}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default ReportShiftComparison;
